/* HerBio product page behaviour. Every component re-initialises on theme-editor section reloads. */
(function () {
  'use strict';

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function onSwipe(el, cb) {
    var x0 = null, y0 = null;
    el.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') { x0 = e.clientX; y0 = e.clientY; } });
    el.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) cb(dx < 0 ? 1 : -1);
    });
    el.addEventListener('pointercancel', function () { x0 = null; });
  }

  /* Generic tabs: [data-hb-tabs] holds [role=tab] buttons whose aria-controls point at panels. */
  function initTabs(list) {
    if (list.dataset.hbReady) return;
    list.dataset.hbReady = '1';
    var tabs = $$('[role="tab"]', list);
    var dots = list.dataset.hbDots ? $$('span', document.getElementById(list.dataset.hbDots)) : [];
    function pick(i, focus) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
        if (dots[n]) dots[n].classList.toggle('is-on', on);
      });
      if (focus) tabs[i].focus();
      if (list.classList.contains('hb-row') && tabs[i].scrollIntoView) {
        var r = tabs[i].getBoundingClientRect(), lr = list.getBoundingClientRect();
        if (r.left < lr.left || r.right > lr.right) list.scrollBy({ left: r.left - lr.left - 16, behavior: reduced() ? 'auto' : 'smooth' });
      }
      var panelEl = document.getElementById(tabs[i].getAttribute('aria-controls'));
      if (panelEl) $$('[data-hb-clamp]', panelEl).forEach(checkClamp);
    }
    list.hbPick = pick;
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { pick(i); }); });
    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
      if (n === null) return;
      e.preventDefault();
      pick((n + tabs.length) % tabs.length, true);
    });
    if (list.dataset.hbSwipe) {
      var area = document.getElementById(list.dataset.hbSwipe);
      if (area) onSwipe(area, function (dir) {
        var cur = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
        pick((cur + dir + tabs.length) % tabs.length);
      });
    }
  }

  /* Read more on long text */
  function checkClamp(box) {
    var btn = box.parentElement && box.parentElement.querySelector('[data-hb-readmore]');
    if (!btn) return;
    if (box.dataset.open === '1') { btn.hidden = false; return; }
    box.classList.add('is-clamped');
    btn.hidden = box.scrollHeight <= box.clientHeight + 2;
    if (btn.hidden) box.classList.remove('is-clamped');
  }
  function initClamp(box) {
    if (box.dataset.hbReady) return;
    box.dataset.hbReady = '1';
    var btn = box.parentElement.querySelector('[data-hb-readmore]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = box.dataset.open !== '1';
      box.dataset.open = open ? '1' : '0';
      box.classList.toggle('is-clamped', !open);
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    checkClamp(box);
  }

  /* Arrow buttons that scroll a row by one card */
  function initScrollButtons(btn) {
    if (btn.dataset.hbReady) return;
    btn.dataset.hbReady = '1';
    btn.addEventListener('click', function () {
      var row = document.getElementById(btn.dataset.hbScroll);
      if (!row) return;
      var first = row.firstElementChild;
      var step = first ? first.getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 0) : row.clientWidth;
      row.scrollBy({ left: step * +btn.dataset.dir, behavior: reduced() ? 'auto' : 'smooth' });
    });
  }

  /* Gallery: native scroll-snap track, arrows, counter, thumbnails */
  function initGallery(g) {
    if (g.dataset.hbReady) return;
    g.dataset.hbReady = '1';
    var track = g.querySelector('[data-hb-gal-track]');
    var slides = $$('[data-hb-slide]', g);
    var thumbs = $$('[data-hb-thumb]', g);
    var pos = g.querySelector('[data-hb-gal-pos]');
    if (!track || !slides.length) return;
    var cur = 0;
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduced() ? 'auto' : 'smooth' });
    }
    function mark(i) {
      cur = i;
      if (pos) pos.textContent = i + 1;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var t = thumbs[i];
      if (t && t.parentElement) {
        var row = t.parentElement, r = t.getBoundingClientRect(), lr = row.getBoundingClientRect();
        if (r.left < lr.left || r.right > lr.right) row.scrollBy({ left: r.left - lr.left - 8, behavior: 'auto' });
      }
    }
    var tick = null;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== cur) mark(Math.max(0, Math.min(slides.length - 1, i)));
      }, 60);
    }, { passive: true });
    $$('[data-hb-gal-step]', g).forEach(function (b) { b.addEventListener('click', function () { go(cur + +b.dataset.hbGalStep); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); mark(i); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
  }

  /* Product: pack selection, price binding, sticky bar, add to cart and buy now */
  function initProduct(root) {
    if (root.dataset.hbReady) return;
    root.dataset.hbReady = '1';
    var dataEl = root.querySelector('[data-hb-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
    var input = root.querySelector('[data-hb-variant-input]');
    var form = input ? input.form : null;
    var mainAdd = root.querySelector('[data-hb-add-main]');
    var labels = { add: root.dataset.labelAdd, soldout: root.dataset.labelSoldout };

    function current() {
      var id = input ? +input.value : 0;
      return variants.find(function (v) { return v.id === id; }) || variants[0];
    }
    function render(v) {
      if (!v) return;
      $$('[data-hb-pack]', root).forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.hbPack === v.id ? 'true' : 'false'); });
      $$('[data-hb-bind]', root).forEach(function (el) {
        var key = el.dataset.hbBind;
        var val = v[key] || '';
        if (key === 'label' && el.dataset.hbSuffix) val = val + el.dataset.hbSuffix;
        if (el.dataset.hbPrefix) val = val ? el.dataset.hbPrefix + val : '';
        el.textContent = val;
        if (el.hasAttribute('data-hb-hide-empty')) el.hidden = !val;
      });
      $$('[data-hb-add], [data-hb-buy], [data-hb-add-main]', root).forEach(function (b) {
        b.disabled = !v.available;
      });
      if (mainAdd) {
        var span = mainAdd.querySelector('span');
        if (span) span.textContent = v.available ? labels.add : labels.soldout;
      }
    }
    function select(id) {
      var v = variants.find(function (x) { return x.id === id; });
      if (!v || !input) return;
      input.value = v.id;
      render(v);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      }
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hb-pack]');
      if (b) { select(+b.dataset.hbPack); return; }
      var add = e.target.closest('[data-hb-add]');
      if (add && form) {
        e.preventDefault();
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        return;
      }
      var buy = e.target.closest('[data-hb-buy]');
      if (buy) { e.preventDefault(); buyNow(buy); }
    });

    function buyNow(btn) {
      var v = current();
      if (!v || !v.available || btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('loading');
      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = rootUrl() + 'checkout';
      }).catch(function () {
        btn.disabled = false;
        btn.classList.remove('loading');
        var err = root.querySelector('.product-form__error-message-wrapper');
        var msg = root.querySelector('.product-form__error-message');
        if (err && msg) { msg.textContent = root.dataset.labelError || 'Something went wrong. Please try again.'; err.hidden = false; }
      });
    }
    render(current());
  }

  /* Doctor carousel */
  function initDocs(box) {
    if (box.dataset.hbReady) return;
    box.dataset.hbReady = '1';
    var track = box.querySelector('[data-hb-docs-track]');
    var cards = $$('[data-hb-doc]', box);
    var cats = $$('[data-hb-cat]', box);
    var dots = $$('[data-hb-docs-dots] span', box);
    var prev = box.querySelector('[data-hb-docs-prev]');
    var next = box.querySelector('[data-hb-docs-next]');
    var carousel = box.querySelector('.hb-docs__carousel');
    if (!track || !cards.length) return;
    var idx = 0;
    function vis() { return parseInt(getComputedStyle(carousel).getPropertyValue('--vis'), 10) || 2; }
    function max() { return Math.max(0, cards.length - vis()); }
    function render() {
      idx = Math.min(idx, max());
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var pitch = cards[0].getBoundingClientRect().width + gap;
      track.style.transform = 'translateX(' + (-idx * pitch) + 'px)';
      var active = 0;
      cats.forEach(function (c, i) { if (+c.dataset.hbStart <= idx + (idx >= max() && max() > 0 ? vis() - 1 : 0)) active = i; });
      cats.forEach(function (c, i) { c.setAttribute('aria-pressed', i === active ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === active); });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx >= max();
      cards.forEach(function (c, i) { c.setAttribute('aria-hidden', i >= idx && i < idx + vis() ? 'false' : 'true'); });
    }
    function move(to) { idx = Math.max(0, Math.min(max(), to)); render(); }
    if (prev) prev.addEventListener('click', function () { move(idx - 1); });
    if (next) next.addEventListener('click', function () { move(idx + 1); });
    cats.forEach(function (c) { c.addEventListener('click', function () { move(+c.dataset.hbStart); }); });
    onSwipe(box.querySelector('[data-hb-docs-viewport]'), function (dir) { move(idx + dir); });
    var rt = null;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(render, 120); });
    render();
  }

  /* FAQ: one open at a time (for browsers without exclusive <details name>) */
  function initFaq(list) {
    if (list.dataset.hbReady) return;
    list.dataset.hbReady = '1';
    var items = $$('details', list);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    $$('[data-hb-product]', scope).forEach(initProduct);
    $$('[data-hb-gallery]', scope).forEach(initGallery);
    $$('[data-hb-tabs]', scope).forEach(initTabs);
    $$('[data-hb-clamp]', scope).forEach(initClamp);
    $$('[data-hb-scroll]', scope).forEach(initScrollButtons);
    $$('[data-hb-docs]', scope).forEach(initDocs);
    $$('[data-hb-faq]', scope).forEach(initFaq);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
